<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <b-tabs class="gridtabs">
                            <b-tab>
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>
                                    {{ selection[0].entry }}
                                </template>

                                <!-- <p class="py-2 px-0"> -->
                                <b-row class="mt-3 mb-3 mx-n3">
                                    <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark"><span class="list-label">To:
                                                    {{ item.slac }}</span> {{ item.to }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Your
                                                    Ref/PO:</span>{{ item.yourref }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Invoice
                                                    No:</span>{{ item.ref }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Issued:</span>{{
                                                $moment.unix(item.dateref * 0.001).format("DD/MM/YYYY")
                                            }}</b-list-group-item>
                                            <!-- <b-list-group-item variant="dark"><span class="list-label">Due
                                                    on:</span>{{ item.datedue }}</b-list-group-item> -->

                                        </b-list-group></b-col>
                                    <b-col cols="auto"> <b-list-group horizontal="md" size="sm">

                                            <b-list-group-item variant="dark-primary"><span
                                                    class="list-label">Amount:</span>{{ total | currency("")
                                                    }}</b-list-group-item>
                                            <!-- <b-list-group-item variant="dark-primary"><span class="list-label">Due:</span>{{
                                                total | currency("")
                                            }}</b-list-group-item> -->
                                        </b-list-group></b-col>
                                    <div>

                                    </div>
                                </b-row>

                                <p>
                                    <b-tabs>
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-1 mr-1 w-60px">
                                                    <i :class="lines.icon" class="ml-1"></i> Lines
                                                    <b-badge variant="white" class="edit_tab">
                                                    </b-badge>

                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable nested"
                                                        refid="segments" :icon="lines.icon" :selectmode="'single'"
                                                        :busy="lines.busy" :tools="lines.tools" :badges="lines.badges"
                                                        :fields="lines.fields" :items="lines.items" :page="lines.page"
                                                        :showpages="false" @load="lines_load" @click="lines_click"
                                                        @select="lines_select" @totalled="lines_total">
                                                    </d-table>
                                                </b-col>
                                            </b-row>

                                            <b-tabs v-if="lines.item.lineno" class="gridtabs mt-2">

                                                <b-tab>
                                                    <template #title>
                                                        <span class="text-primary">{{lines.items.map(o =>
                                                            o.lineno).indexOf(lines.item.lineno) + 1
                                                        }}.</span>
                                                        <i :class="'fa fa fa-arrows-h text-info'"
                                                            class="text-primary ml-1 mr-1"></i>
                                                        <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                            : "edit" }}&gt;</span>&nbsp;


                                                    </template>

                                                    <p class="py-0 px-0 ">
                                                        <b-card class="nopadding mt-0 "><b-card-body>

                                                                <div class="px-0 mt-2">

                                                                    <b-row>

                                                                        <b-col cols="12" sm="4" md="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Transaction Date" label-size="sm">
                                                                                <b-input-group>
                                                                                    <daterangepicker
                                                                                        style="width:auto !important"
                                                                                        size="sm" ref="date"
                                                                                        v-model="mapper_date_at"
                                                                                        :opens="'right'"
                                                                                        :single-date-picker="'single'"
                                                                                        :locale-data="{
                                                                                            direction: 'ltr',
                                                                                            format: 'dd/mm/yy HH:MM',
                                                                                            daysOfWeek: [
                                                                                                'Sun',
                                                                                                'Mon',
                                                                                                'Tue',
                                                                                                'Wed',
                                                                                                'Thu',
                                                                                                'Fri',
                                                                                                'Sat',
                                                                                            ],
                                                                                            monthNames: [
                                                                                                'January',
                                                                                                'February',
                                                                                                'March',
                                                                                                'April',
                                                                                                'May',
                                                                                                'June',
                                                                                                'July',
                                                                                                'August',
                                                                                                'September',
                                                                                                'October',
                                                                                                'November',
                                                                                                'December',
                                                                                            ],
                                                                                            firstDay: 1,
                                                                                        }" :ranges="false"
                                                                                        :showDropdowns="true"
                                                                                        :linkedCalendars="true"
                                                                                        :timePicker="true"
                                                                                        :timePicker24Hour="true"
                                                                                        :time-picker-increment="1">
                                                                                    </daterangepicker>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="mapper_date_at = { startDate: null, endDate: null }"
                                                                                            :disabled="true">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>

                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Ledger Type"
                                                                                label-for="type" label-cols="12">
                                                                                <b-input-group>
                                                                                    <treeselect instanceId="type"
                                                                                        type="number"
                                                                                        v-model="lines.item.ledger"
                                                                                        :clearable="true"
                                                                                        :options="type_options">
                                                                                    </treeselect>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Line"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input v-model="lines.item.lineno"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Line"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.lineno"
                                                                                            @click="lines.item.lineno = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="N/L Accounts" label-size="sm">
                                                                                <treeselect instanceId="nlcode"
                                                                                    type="number"
                                                                                    v-model="lines.item.nlcode"
                                                                                    :clearable="true"
                                                                                    :options="nlcode_options">
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Transaction Type"
                                                                                label-for="transtype" label-cols="12">
                                                                                <b-input-group>
                                                                                    <treeselect instanceId="transtype"
                                                                                        type="number"
                                                                                        v-model="lines.item.transtype"
                                                                                        :clearable="true"
                                                                                        :options="transaction_options">
                                                                                    </treeselect>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>


                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Transaction Date"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-datepicker size="sm"
                                                                                        v-model="lines.item.dateref"
                                                                                        label-help hide-header
                                                                                        locale="en-GB"
                                                                                        placeholder="From"
                                                                                        :debounce="lines.debounce"
                                                                                        :date-format-options="{
                                                                                            year: 'numeric',
                                                                                            month: 'numeric',
                                                                                            day: 'numeric',
                                                                                        }"></b-form-datepicker>

                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm" squared
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.dateref"
                                                                                            @click="item.dateref = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->


                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Ref"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.ref"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Ref"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.ref"
                                                                                            @click="lines.item.ref = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="4" md="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Depart Date" label-size="sm">
                                                                                <b-input-group>
                                                                                    <daterangepicker class="w-auto sm"
                                                                                        size="sm" ref="travel_at"
                                                                                        v-model="mapper_travel_at"
                                                                                        :opens="'right'" :locale-data="{
                                                                                            direction: 'ltr',
                                                                                            format: 'dd/mm/yyyy',
                                                                                            daysOfWeek: [
                                                                                                'Sun',
                                                                                                'Mon',
                                                                                                'Tue',
                                                                                                'Wed',
                                                                                                'Thu',
                                                                                                'Fri',
                                                                                                'Sat',
                                                                                            ],
                                                                                            monthNames: [
                                                                                                'January',
                                                                                                'February',
                                                                                                'March',
                                                                                                'April',
                                                                                                'May',
                                                                                                'June',
                                                                                                'July',
                                                                                                'August',
                                                                                                'September',
                                                                                                'October',
                                                                                                'November',
                                                                                                'December',
                                                                                            ],
                                                                                            firstDay: 1,
                                                                                            applyLabel: 'OK',
                                                                                            cancelLabel: 'Cancel',
                                                                                        }" :ranges="false" :showDropdowns="true"
                                                                                        :single-date-picker="'single'"
                                                                                        :timePicker="false"
                                                                                        :timePicker24Hour="false"
                                                                                        :time-picker-increment="1">
                                                                                    </daterangepicker>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="mapper_travel_at = {
                                                                                                startDate: null,
                                                                                                endDate: null,
                                                                                            }
                                                                                                ">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Depart Date" label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-datepicker size="sm"
                                                                                        v-model="lines.item.datedepart"
                                                                                        label-help hide-header
                                                                                        locale="en-GB"
                                                                                        placeholder="From"
                                                                                        :debounce="lines.debounce"
                                                                                        :date-format-options="{
                                                                                            year: 'numeric',
                                                                                            month: 'numeric',
                                                                                            day: 'numeric',
                                                                                        }"></b-form-datepicker>

                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm" squared
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.datedepart"
                                                                                            @click="item.datedepart = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->


                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Credit" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="item.credit"
                      :debounce="lines.debounce"
                      placeholder="Credit"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!item.credit"
                        @click="item.credit = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Supplier BL A/C" label-size="sm">
                                                                                <treeselect placeholder="Select blac..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="lines.item.blac"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadBLAC"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested>
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Client SL A/C" label-size="sm">
                                                                                <treeselect placeholder="Select slac..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="lines.item.slac"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadSLAC"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested>
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Sales Group"
                                                                                label-for="salesgroup" label-cols="12">
                                                                                <treeselect
                                                                                    placeholder="Select sales group..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="lines.item.salesgroup"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadSalesgroups"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested>
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Event"
                                                                                label-size="sm">
                                                                                <treeselect
                                                                                    placeholder="Select event..."
                                                                                    v-model="lines.item.eventcode"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadEvent"
                                                                                    searchPromptText="Type at least 4 chars..."
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested>
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>




                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Amount"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.amount"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Amount"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.amount"
                                                                                            @click="lines.item.amount = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Batch"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input v-model="lines.item.batch"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Batch"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.batch"
                                                                                            @click="lines.item.batch = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->

                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="BK Form"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.bkform"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="BK Form"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.bkform"
                                                                                            @click="lines.item.bkform = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Status"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.status"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Status"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.status"
                                                                                            @click="lines.item.status = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Prog"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input v-model="lines.item.prog"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Prog"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.prog"
                                                                                            @click="lines.item.prog = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Autosource"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.autosource"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Autosource"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.autosource"
                                                                                            @click="lines.item.autosource = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->

                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Revent"
                                                                                label-size="sm">
                                                                                <treeselect placeholder="Select revent..."
                                                                                    searchPromptText="Type at least 4 chars..."
                                                                                    v-model="lines.item.revent"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadEvent"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" :disabled="readonly"
                                                                                    search-nested>
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Travel AP"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.travelap"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Travel AP"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.travelap"
                                                                                            @click="lines.item.travelap = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Linked Entry" label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.linkedentry"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Linked Entry"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.linkedentry"
                                                                                            @click="lines.item.linkedentry = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->

                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Year"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input v-model="lines.item.year"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Year"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.year"
                                                                                            @click="lines.item.year = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Entry"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.entry"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Entry"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.entry"
                                                                                            @click="lines.item.entry = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="AP"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.ap"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="AP"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.ap"
                                                                                            @click="lines.item.ap = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Period"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.period"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Period"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.period"
                                                                                            @click="lines.item.period = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Age"
                                                                                label-size="sm">
                                                                                <b-input-group>
                                                                                    <b-form-input
                                                                                        v-model="lines.item.age"
                                                                                        :debounce="lines.debounce"
                                                                                        placeholder="Age"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            :disabled="!lines.item.age"
                                                                                            @click="lines.item.age = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-row>
                                                                                <b-col>
                                                                                    <b-form-group label-cols="12"
                                                                                        label="Future?" label-size="sm">
                                                                                        <b-form-radio-group id="future"
                                                                                            v-model="lines.item.future"
                                                                                            :options="[
                                                                                                { text: 'Yes', value: true },
                                                                                                { text: 'No', value: false },
                                                                                            ]" buttons
                                                                                            button-variant="outline-success"
                                                                                            size="sm"
                                                                                            name="radio-btn-outline"></b-form-radio-group>
                                                                                    </b-form-group>
                                                                                </b-col>
                                                                                <b-col>
                                                                                    <b-form-group label-cols="12"
                                                                                        label="Cleared?" label-size="sm">
                                                                                        <b-form-radio-group id="cleared"
                                                                                            v-model="lines.item.cleared"
                                                                                            :options="[
                                                                                                { text: 'Yes', value: true },
                                                                                                { text: 'No', value: false },
                                                                                            ]" buttons
                                                                                            button-variant="outline-success"
                                                                                            size="sm"
                                                                                            name="radio-btn-outline"></b-form-radio-group>
                                                                                    </b-form-group>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12" label="Reversed?"
                                                                                label-size="sm">
                                                                                <b-form-radio-group id="reversed"
                                                                                    v-model="lines.item.reversed" :options="[
                                                                                        { text: 'Yes', value: true },
                                                                                        { text: 'No', value: false },
                                                                                    ]" buttons
                                                                                    button-variant="outline-success"
                                                                                    size="sm"
                                                                                    name="radio-btn-outline"></b-form-radio-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                    </b-row>



                                                                </div>
                                                            </b-card-body>
                                                            <!-- 
                                                            <b-card-footer class="mt-4 mb-2">
                                                                <b-row>
                                                                    <b-col class="text-left">
                                                                        <div v-if="busy">
                                                                            <i
                                                                                class="fa fa-spinner fa-spin text-primary"></i>
                                                                        </div>
                                                                        <div v-else>
                                                                            <span v-html="message_lines"></span>
                                                                        </div>
                                                                    </b-col>
                                                                    <b-col class="text-right" cols="8">
                                                                        <b-button squared size="sm" variant="primary"
                                                                            @click="lines_save()">
                                                                            <i class="fa fa-check"></i>
                                                                            Post It
                                                                        </b-button>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-card-footer> -->
                                                        </b-card>
                                                    </p>
                                                </b-tab>
                                                <b-tab v-if="lines.item.id">
                                                    <template #title>
                                                        <i class="fa fa-comments-o text-primary mr-1"></i>
                                                        Notes</template>
                                                    <p class="py-3 px-0">
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group label="Notes" label-for="notes"
                                                                    label-cols="12">
                                                                    <b-form-textarea id="data"
                                                                        v-model="lines.item.notes" placeholder="Notes"
                                                                        rows="6" class="smalltextarea"
                                                                        :disabled="readonly"></b-form-textarea>
                                                                </b-form-group> </b-col></b-row>

                                                    </p>
                                                </b-tab>


                                                <b-tab v-if="lines.item.id">
                                                    <template #title>
                                                        <i class="fa fa-history text-primary mr-1"></i>Audit
                                                    </template>
                                                    <p class="py-3 px-0">
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created At" label-for="created_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="lines.item.created_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="lines.item.created_at" type="text"
                                                                            placeholder="YYYY-MM-DD" autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.created_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created By" label-for="created_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.created_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.created_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated At" label-for="updated_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="lines.item.updated_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="lines.item.updated_at" type="text"
                                                                            placeholder="YYYY-MM-DD" autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.updated_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated By" label-for="updated_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.updated_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="lines.item.updated_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="ID" label-for="id" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="lines.item.id" placeholder=""
                                                                            size="sm" :disabled="true"></b-form-input>

                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                        </b-row>
                                                    </p>
                                                </b-tab>
                                            </b-tabs>
                                        </b-tab>

                                    </b-tabs>
                                </p>

                            </b-tab>


                        </b-tabs>

                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left mr-4">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="user.permissions.includes('salesledger.save')">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "NLItemEdit",
    async mounted() {
        this.item.agent = this.user.initials;
    },
    data() {
        return {
            busy: false,
            message: "",
            credit: false,
            subtotal: 0,
            totalvat: 0,
            total: 0,
            type_options: [
                { id: "BL", label: "Bought Ledger | BL" },
                { id: "SL", label: "Sales Ledger | SL" },
                { id: "NL", label: "Nominal Ledger | NL" },
            ],
            transaction_options: [
                { id: "BLP", label: "Bought Ledger Payment | BLP" },
                { id: "SLP", label: "Sales Ledger Payment | SLP" },
                { id: "GLJ", label: "Nominal Ledger | GLJ" },
                { id: "INV", label: "Invoice | INV" },
                { id: "CRD", label: "Credit | CRD" },
            ],
            nlcode_options: [],
            // suppliertype_options: [],
            // invoicetype_options: [
            //     { id: "A", label: "A ( air )" },
            //     { id: "X", label: "X ( air )" },
            //     { id: "C", label: "C ( car )" },
            //     { id: "H", label: "H ( hotel )" },
            // ],
            // vatcode_options: [
            //     { id: "0", label: "0" },
            //     { id: "1", label: "1" },
            // ],
            multiple: true,
            mapper_date_at: {
                startDate: this.$moment().format("YYYY-MM-DD HH:mm"),
                endDate: this.$moment().format("YYYY-MM-DD HH:mm"),
            },
            mapper_travel_at: {
                startDate: null,
                endDate: null,
            },
            item: {
                type: "A",
                datetax: this.$moment().format("YYYY-MM-DD"),
                datedepart: this.$moment().format("YYYY-MM-DD"),
                slac: null,
                agent: null,
                ticketno: null,
                items: [{ name: "Passenger 1", ticketno: "abc", id: 0 }],
            },
            items: [],
            lines: {
                title: "Lines",
                icon: "fa fa-list text-info",
                debounce: 500,
                busy: false,
                tools: "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "dateref",
                        label: "Date",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "ledger",
                        label: "Type",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    // {
                    //     key: "line",
                    //     label: "Line",
                    //     sortable: true,
                    // },
                    {
                        key: "nlcode",
                        label: "NL A/C",
                        sortable: true,
                    },
                    {
                        key: "transtype",
                        label: "Trans",
                        sortable: true,
                    },

                    
                    {
                        key: "ref",
                        label: "Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        // formatter: (value, key, item) => {
                        //   if (value) {
                        //     return parseFloat(value).toFixed(2);
                        //   } else {
                        //     return value;
                        //   }
                        // },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "period",
                        label: "Period",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "age",
                        label: "Age",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },

                    {
                        key: "credit",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "text-center actions w-sm-100pct",
                    // },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: []
            }
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('salesledger.admin')) {
                return false
            }
            return true;
        },
        readonly_age() {
            if (this.user.permissions.includes('salesledger.admin') && this.item.age == 0) {
                return false;
            }
            return true;
        },
    },
    watch: {
        mapper_date_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.lines.item.dateref = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },
        mapper_travel_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.lines.item.datedepart = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },

    },
    methods: {
        async loadDDL() {
            //this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
                });
                this.nlcode_options = response.data.nlcodes;
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async load() {
            await this.lines_load();
        },
        async lines_load(offset, limit, page) {

            if (page) {
                this.lines.page = page
            }

            // if (!this.agent) { return }

            this.lines.busy = true;
            this.lines.items = [];

            let variables = {
                // entry: this.selection[0].entry,
                id: this.selection.map(q => q.id).join(",")
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query NLTransactions(
              $offset: Int
              $limit: Int            
              $id: String
              $entry: String
            ) {
              NLTransactions(
                offset: $offset
                limit: $limit
                id: $id
                entry: $entry

              ) {
                id
                entry
                lineno
                ref
                nlcode
                dateref
                datedepart
                blac
                slac
                eventcode
                amount
                ledger
                credit
                # batch
                ap
                age
                period
                # year
                # travelap
                # salesgroup
                # revent
                transtype
                # future
                # cleared
                # reversed
                notes
                updated_at
                updated_by
                rows
              }
            }
          `,
                    variables,
                });

                this.item = response.data.NLTransactions[0]
                this.lines.items = response.data.NLTransactions

                let startDate = this.$moment.unix(this.lines.items[0].dateref * 0.001).utc(true).format("YYYY-MM-DD HH:mm")
                let endDate = startDate
                this.mapper_date_at = { startDate, endDate }

                if (this.lines.items[0].datedepart) {
                    startDate = this.$moment.unix(this.lines.items[0].datedepart * 0.001).utc(true).format("YYYY-MM-DD")
                    endDate = startDate
                    this.mapper_travel_at = { startDate, endDate }
                }

            } catch (error) {
                console.log(error);
            }
            this.lines.busy = false;
        },
        async lines_click(a, ss) {
            console.log("lines_click", a, ss);

            let state = this.lines;

            switch (a) {

                case "go":
                    this.component = null;
                    await this.lines_load();
                    break;

                case "save":
                    await this.lines_saveit()
                    break;

            }
        },
        async lines_select(ss, tools) {
            console.log("lines_select", ss);

            let state = this.lines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = { ...state.selected[0] }; // WHAT YOU SELECTED

                // state.item.dateref = this.$moment.unix(state.item.dateref * 0.001).utc(true).format("YYYY-MM-DD")
                // state.item.datedepart = this.$moment.unix(state.item.datedepart * 0.001).utc(true).format("YYYY-MM-DD")

            } else {
                state.item = {}
            }
        },
        async lines_total(f) {
            console.log('lines_total', f)
            let found = f.find(o => o.key == 'amount')
            if (found) {
                this.total = found.total
            }

        },

        async saveit() {
            this.busy = true;

            // ONLY SEND WHAT WE ARE ALLOWED TO UPDATE
            let rows = [this.cleanit(this.lines.item)]
            console.log(rows)

            let variables = {
                rows,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation NLTransactions_save($rows: [NLTransaction_input]) {
                        NLTransactions_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });

                await this.load()

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
    },
};
</script>